
import { depotRequeteBasePath } from './depot-requete.data';

interface StepDetailInit {
    route: string;
    breadTitle: string;
    pageTitle?: string;
}

export class StepDetail {
    public route: string;
    public breadTitle: string;
    private readonly _pageTitle?: string;

    constructor(stepDetailInit: StepDetailInit) {
        this.route = stepDetailInit.route;
        this.breadTitle = stepDetailInit.breadTitle;
        this._pageTitle = stepDetailInit.pageTitle;
    }

    get pageTitle(): string {
        return this._pageTitle || this.breadTitle;
    }

    get fullRoute(): string {
        return `${depotRequeteBasePath}/${this.route}`
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/depot-requete.model.ts